import { Capacitor } from '@capacitor/core';

/**
 * Fascia opaca fissa dietro la barra di stato del sistema (ora, batteria, rete…).
 *
 * Senza questa fascia, scrollando verso il basso il contenuto dell'app finisce
 * sotto la status bar (il `padding-top` del body è solo un offset iniziale e
 * scorre via), rendendo illeggibili ora/batteria — come in Instagram, vogliamo
 * invece un pannello solido sempre presente in cima.
 *
 * Altezza = stessa area riservata dal body (`max(env(safe-area-inset-top), 20px)`
 * in `index.css`), così combacia senza fasce vuote o salti.
 *
 * Solo su app nativa: su web `env(safe-area-inset-top)` è 0 e una fascia di
 * 20px in cima al sito non avrebbe senso.
 */
const StatusBarBackdrop = () => {
  if (!Capacitor.isNativePlatform()) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'max(env(safe-area-inset-top), 20px)',
        background: '#ffffff',
        zIndex: 9990,
        pointerEvents: 'none',
      }}
    />
  );
};

export default StatusBarBackdrop;
